import React from 'react';
import MainNavigation from './MainNavigation';
import SiteFooter from './SiteFooter';
import AnalyticsPageTracker from './AnalyticsTracker';
import PaddleResourcePreloader from './PaddlePreloader';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <AnalyticsPageTracker />
      <PaddleResourcePreloader />
      <MainNavigation />
      <main className="flex-grow">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
};

export default Layout; 